import { CampaignDeletionResult, campaignDeletionResultSchema } from "@signalist/shared-types";

import { api } from "@/redux/api";

import { List, ListSchema } from "../../pages/List/schema/list";

/**
 * Per-campaign flag endpoints (PREC-4026). Kept beside `list.api.ts`, which sits at the
 * file-length ratchet; the endpoints inject into the same api slice and share its `List` tags.
 */
export const listCampaignApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// Moves only the isDefault flag — never re-uploads the campaign's steps.
		setDefaultCampaign: builder.mutation<Partial<List>, { id: number; campaignUuid: string }>({
			query: ({ id, campaignUuid }) => ({
				url: `list/${id}/campaign/${campaignUuid}/default`,
				method: "PATCH",
				responseSchema: ListSchema,
			}),
			invalidatesTags: (result, error, arg) => [{ type: "List", id: arg.id }],
		}),
		// The one campaign delete (PREC-4258): the campaign goes, its pending steps are cancelled and
		// its leads leave it, so the list, its lead tables and the assigned counts are refetched.
		deleteCampaign: builder.mutation<CampaignDeletionResult, { id: number; campaignUuid: string }>({
			query: ({ id, campaignUuid }) => ({
				url: `list/${id}/campaign/${campaignUuid}`,
				method: "DELETE",
				responseSchema: campaignDeletionResultSchema,
			}),
			invalidatesTags: (result, error, arg) => [
				{ type: "List", id: arg.id },
				{ type: "ListAssignedToCampaign", id: arg.id },
				"ListPerson",
			],
		}),
	}),
});

export const { useSetDefaultCampaignMutation, useDeleteCampaignMutation } = listCampaignApi;
